{
  "login.header_langauge": {
    "nb": "Språk",
    "nn": "Språk",
    "en": "Language"
  },
  "generic.language_nb": {
    "nb": "Bokmål",
    "nn": "Bokmål",
    "en": "Bokmål"
  },
  "generic.language_nn": {
    "nb": "Nynorsk",
    "nn": "Nynorsk",
    "en": "Nynorsk"
  },
  "generic.language_en": {
    "nb": "English",
    "nn": "English",
    "en": "English"
  },
  "generic.next": {
    "nb": "Neste",
    "nn": "Neste",
    "en": "Next"
  },
  "generic.search": {
    "nb": "Søk",
    "nn": "Søk",
    "en": "Search"
  },
  "generic.back": {
    "nb": "Tilbake",
    "nn": "Tilbake",
    "en": "Back"
  },
  "generic.orgnr": {
    "nb": "Organisasjonsnummer",
    "nn": "Organisasjonsnummer",
    "en": "Organisation number"
  },
  "generic.business": {
    "nb": "Virksomhet",
    "nn": "Verksemd",
    "en": "Business"
  },
  "generic.error": {
    "nb": "En feil har oppstått. Vennligst prøv igjen, eller ta kontakt med kundeservice på kundeservice@digipost.no.",
    "nn": "Ein feil har oppstått. Ver vennleg og prøv igjen, eller ta kontakt med kundeservice på kundeservice@digipost.no.",
    "en": "An error has occurred. Please try again, or contact customer support at kundeservice@digipost.no."
  },
  "generic.name": {
    "nb": "Navn",
    "nn": "Namn",
    "en": "Name"
  },
  "login.header": {
    "nb": "Registrer virksomhet",
    "nn": "Registrer verksemd",
    "en": "Register business"
  },
  "login.body": {
    "nb": "For at vi skal kunne finne ut av hvilke organisasjoner du kan lage avtaler med må du identifisere deg med BankID eller Buypass.",
    "nn": "For at me skal kunna finna ut av kva organisasjonar du kan laga avtalar med må du identifisera deg med BankID eller Buypass.",
    "en": "You need to identify yourself with BankID or Buypass so we can find the businesses you can enter into agreements on behalf of. "
  },
  "virksomhet.bankid_title": {
    "nb": "BankID",
    "nn": "BankID",
    "en": "BankID"
  },
  "virksomhet.bankid_desc": {
    "nb": "Kodebrikke eller app",
    "nn": "Kodebrikke eller app",
    "en": "Code device or app"
  },
  "virksomhet.buypass_title": {
    "nb": "Buypass",
    "nn": "Buypass",
    "en": "Buypass"
  },
  "virksomhet.buypass_desc": {
    "nb": "Bruk smartkort til innlogging",
    "nn": "Bruk smartkort til innlogging",
    "en": "Use smart card to login"
  },
  "virksomhet.velg.header" : {
    "nb": "Velg virksomhet",
    "nn": "Vel verksemd",
    "en": "Choose business"
  },
  "virksomhet.velg.not_found": {
    "nb": "Finner du ikke virksomheten din?",
    "nn": "Finn du ikkje verksemda di?",
    "en": "Can't find your business?"
  },
  "virksomhet.velg.not_found_link": {
    "nb": "Gå til manuell registrering.",
    "nn": "Gå til manuell registrering.",
    "en": "Go to manual registration."
  },
  "virksomhet.velg.allerede_registrert": {
    "nb": "Virksomheten du har valgt er allerede registrert i både Digipost og Posten Signering. Ta kontakt med kundeservice om du trenger hjelp. kundeservice@digipost.no",
    "nn": "Verksemda du har valt er allereie registrert i både Digipost og Posten Signering. Ta kontakt med kundeservice om du treng hjelp. kundeservice@digipost.no",
    "en": "The business you've chosen is already registered in both Digipost and Posten Signering. Contact customer support if you need help. kundeservice@digipost.no"
  },
  "virksomhet.registrer.allerede-registrert": {
    "nb": "Vi kan ikke automatisk registrere den valgte bedriften, fordi den allerede er registrert i #{eksisterende}",
    "nn": "Me kan ikkje automatisk registrera den valde bedrifta, fordi ho allereie er registrert i #{eksisterende}",
    "en": "We can't automatically register the selected business, because it is already registered for #{eksisterende}"
  },
  "contact.header": {
    "nb": "Kontaktinformasjon",
    "nn": "Kontaktinformasjon",
    "en": "Contact information"
  },
  "contact.body": {
    "nb": "Vi bruker kontaktinformasjonen for å sende deg varslinger og gjøre tjenesten bedre for deg.",
    "nn": "Me bruker kontaktinformasjonen for å senda deg varslingar og gjera tenesta betre for deg.",
    "en": "We use the contact information to send you notifications and to improve the service for you."
  },
  "contact.email": {
    "nb": "E-postadresse",
    "nn": "E-postadresse",
    "en": "Email"
  },
  "contact.email_personal": {
    "nb": "Din e-post",
    "nn": "Din e-post",
    "en": "Your email"
  },
  "contact.email_company": {
    "nb": "Virksomhetens e-post",
    "nn": "E-posten for verksemda",
    "en": "Business email"
  },
  "manual.find_orgnr": {
    "nb": "Finn virksomhet",
    "nn": "Finn verksemd",
    "en": "Find business"
  },
  "manual.no_results_body": {
    "nb": "Vi finner ingen virksomheter du har rett til å opprette i Digipost. Søk opp virksomheten din eller <a href=\"https://www.digipost.no/bedrift/hjelp-og-kontakt\" target=\"_blank\" rel=\"noopener noreferrer\">ta kontakt med oss.</a>",
    "nn": "Vi finn ingen verksemder du har rett til å opprette i Digipost. Søk opp verksemda di eller <a href=\"https://www.digipost.no/nn/bedrift/hjelp-og-kontakt\" target=\"_blank\" rel=\"noopener noreferrer\">ta kontakt med oss.</a>",
    "en": "We cannot find any businesses you have the right to create in Digipost. Search for your business or <a href=\"https://www.digipost.no/en/business/help-and-contact\" target=\"_blank\" rel=\"noopener noreferrer\">contact us.</a>"
  },
  "manual.header": {
    "nb": "Kontaktinformasjon",
    "nn": "Kontaktinformasjon",
    "en": "Contact information"
  },
  "manual.intro": {
    "nb": "Fyll ut feltene nedenfor for å registrere din bedrift",
    "nn": "Fyll ut felta nedanfor for å registrera bedrifta di",
    "en": "Fill in the fields below to register your business"
  },
  "manual.intro_contd": {
    "nb": "Når opplysningene er godkjent av oss, vil du motta en e-post med mer informasjon om din nye bedriftskonto",
    "nn": "Når opplysningane er godkjende av oss, vil du få ein e-post med meir informasjon om den nye bedriftskontoen din.",
    "en": "Once the information has been approved by us, you will receive an email with more information about your new business account."
  },
  "manual.business_name": {
    "nb": "Navn på virksomhet",
    "nn": "Namn på verksemd",
    "en": "Name of business"
  },
  "manual.first_name": {
    "nb": "Fornavn",
    "nn": "Fornamn",
    "en": "First name"
  },
  "manual.surname": {
    "nb": "Etternavn",
    "nn": "Etternamn",
    "en": "Surname"
  },
  "manual.comment": {
    "nb": "Kommentar (Valgfritt)",
    "nn": "Kommentar (Valgfritt)",
    "en": "Comment (Optional)"
  },
  "validation.orgnr": {
    "nb": "Organisasjonsnummeret er ikke gyldig",
    "nn": "Organisasjonsnummeret er ikkje gyldig",
    "en": "Invalid organisation number"
  },
  "validation.business_name": {
    "nb": "Dette feltet må utfylles",
    "nn": "Dette feltet må utfyllast",
    "en": "This field is required"
  },
  "validation.person_name": {
    "nb": "Dette feltet må utfylles",
    "nn": "Dette feltet må utfyllast",
    "en": "This field is required"
  },
  "validation.email": {
    "nb": "Ugyldig e-postadresse",
    "nn": "Ugyldig e-postadresse",
    "en": "Invalid email address"
  },
  "footer.posten": {
    "nb": "En del av Posten Bring-konsernet",
    "nn": "Ein del av Posten Bring-konsernet",
    "en": "A part of Posten Bring Group"
  },
  "footer.cookies": {
    "nb": "Cookies",
    "nn": "Cookies",
    "en": "Cookies"
  },
  "footer.privacy": {
    "nb": "Personvern og sikkerhet",
    "nn": "Personvern og sikkerhet",
    "en": "Privacy policy"
  },
  "summary.header": {
    "nb": "Oppsummering",
    "nn": "Oppsummering",
    "en": "Summary"
  },
  "summary.comment": {
    "nb": "Kommentar",
    "nn": "Kommentar",
    "en": "Comment"
  },
  "summary.none": {
    "nb": "Ingen",
    "nn": "Ingen",
    "en": "None"
  },
  "summary.accept_terms": {
    "nb": "Jeg godtar <a href=\"#{href}\"  target=\"_blank\" rel=\"noopener noreferrer\">vilkårene</a>",
    "nn": "Eg godtek <a href=\"#{href}\"  target=\"_blank\" rel=\"noopener noreferrer\">vilkåra</a>",
    "en": "I accept <a href=\"#{href}\" target=\"_blank\" rel=\"noopener noreferrer\">the terms of agreement</a>"
  },
  "summary.register_button": {
    "nb": "Registrer virksomhet",
    "nn": "Registrer verksemd",
    "en": "Register business"
  },
  "summary.accept_terms_warning": {
    "nb": "Du må akseptere vilkårene",
    "nn": "Du må akseptera vilkåra",
    "en": "You have to accept the terms and conditions"
  },
  "done_manual.header": {
    "nb": "Snart klar til bruk!",
    "nn": "Snart klar til bruk!",
    "en": "Soon be ready for use!"
  },
  "done_manual.body": {
    "nb": "Du vil få en e-post fra oss når alt er klart.",
    "nn": "Du vil få ein e-post frå oss når alt er klart.",
    "en": "You will receive an email from us when everything is ready."
  },
  "errorpage.header": {
    "nb": "En feil har oppstått",
    "nn": "Ein feil har oppstått",
    "en": "An error has occurred"
  },
  "errorpage.body": {
    "nb": "Vennligst prøv igjen senere, eller ta kontakt med kundeservice på kundeservice@digipost.no.",
    "nn": "Ver vennleg og prøv igjen seinare, eller ta kontakt med kundeservice på kundeservice@digipost.no.",
    "en": "Please try again later, or contact customer support at kundeservice@digipost.no."
  },
  "partneronboarding.fullmakt.header": {
    "nb": "Fullmakt",
    "nn": "Fullmakt",
    "en": "Power of Attourney"
  },
  "partneronboarding.fullmakt.infotext": {
    "nb": "Ved å gi fullmakt kan #{partnerName} sende, motta og administrere digital post og sende fysisk post på vegne av #{virksomhet}. Kontakt #{partnerName} for nærmere informasjon.",
    "nn": "Ved å gi fullmakt kan #{partnerName} sende, motta og administrere \ndigital post og sende fysisk post på vegner av #{virksomhet}. Kontakt #{partnerName} for nærmare informasjon.",
    "en": "By granting #{partnerName} power of attourney, they are given the ability to send, receive and manage digital mail and to send physical mail on behalf of #{virksomhet}. Contact #{partnerName} for more information."
  },
  "partneronboarding.fullmakt.checkbox": {
    "nb": "#{virksomhet} godtar at #{partnerName} får fullmakt",
    "nn": "#{virksomhet} godtar at #{partnerName} får fullmakt",
    "en": "#{virksomhet} accepts that #{partnerName} get authorization"
  },
  "partneronboarding.fullmakt.checkbox_warning": {
    "nb": "Du må godta fullmakten for å gå videre",
    "nn": "Du må godta fullmakten for å gå vidare",
    "en": "You must accept the authorization to proceed"
  },
  "partneronboarding.avtalevilkaar.title": {
    "nb": "Avtalevilkår",
    "nn": "Avtalevilkår",
    "en": "Terms of Agreement"
  },
  "partneronboarding.avtalevilkaar.info.one": {
    "nb": "For at #{partnerName} skal kunne handle på vegne av bedriften din i Digipost, må bedriften din først ha en egen Digipost-konto. Dette er fordi vi må ha et kundeforhold til dere, slik at vi kan blant annet holde kontaktinformasjon og opplysninger oppdatert, samt at dere skal kunne bruke de Digipost-tjenestene dere ønsker.",
    "nn": "For at #{partnerName} skal kunne handle på vegner av bedrifta di i Digipost, må bedrifta di først ha ein eigen Digipost-konto. Dette er fordi vi må ha eit kundeforhold til dykk, slik at vi kan blant anna halde kontaktinformasjon og opplysingar oppdatert, samt at de skal kunne bruke dei Digipost-tenestene de ønskjer.",
    "en": "For #{partnerName} to be able to act on behalf of your company in Digipost, the company must first have its own Digipost account. This is because we need to have a customer relation with you, so that we can keep contact information and other details updated, as well as for you to be able to use those Digipost services you wish."
  },
  "partneronboarding.avtalevilkaar.info.two": {
    "nb": "Denne kontoen kan brukes uavhengig av tilknytningen til #{partnerName}. Kontoen er helt gratis å ha og dere betaler kun for det dere eventuelt skulle ønske å bruke.",
    "nn": "Denne kontoen kan brukast uavhengig av tilknyttinga til #{partnerName}. Kontoen er heilt gratis å ha og de betalar berre for det de eventuelt skulle ønskje å bruke.",
    "en": "This account can be used independently from the #{partnerName}. The account is completely free to have and you only pay for what you may use."
  },
  "partneronboarding.avtalevilkaar.info.three": {
    "nb": "Avtalevilkårene som må godtas her er de generelle avtalevilkårene for alle Digipost-bedriftskontoer, og er ikke knyttet til deres forhold til #{partnerName}.",
    "nn": "Avtalevilkåra som må godtakast her er dei generelle avtalevilkåra for alle Digipost-bedriftskontoar, og er ikkje knytta til forholdet dykkar til #{partnerName}.",
    "en": "The terms that must be accepted here are the general terms of agreement for all Digipost business accounts, and are not associated with the relationship between your company and #{partnerName}."
  },
  "partneronboarding.avtalevilkaar.accept_terms": {
    "nb": "Jeg godtar <a href=\"https://digipost.no/juridisk/#for-bedrifter\"  target=\"_blank\" rel=\"noopener noreferrer\">avtalevilkårene</a>",
    "nn": "Eg godtek <a href=\"https://digipost.no/juridisk/#for-bedrifter\"  target=\"_blank\" rel=\"noopener noreferrer\">avtalevilkåra</a>",
    "en": "I accept <a href=\"https://digipost.no/juridisk/#for-bedrifter\" target=\"_blank\" rel=\"noopener noreferrer\">the terms of the agreement</a>"
  },
  "partneronboarding.system_provider": {
    "nb": "Systemleverandør",
    "nn": "Systemleverandør",
    "en": "System provider"
  },
  "partneronboarding.snart_klar.header": {
    "nb": "Snart klar til bruk!",
    "nn": "Snart klar til bruk!",
    "en": "Ready for use soon!"
  },
  "partneronboarding.snart_klar.text": {
    "nb": "Du er snart i mål. Fullfør registreringen din hos #{partnerName}.",
    "nn": "Du er snart i mål. Fullfør registreringa di hos #{partnerName}",
    "en": "You're almost there. Complete your registration at #{partnerName}"
  },
  "partneronboarding.snart_klar.complete": {
    "nb": "Fullfør registreringen",
    "nn": "Fullfør registreringa",
    "en": "Complete registration"
  },
  "infopage.header": {
    "nb": "Kom i gang",
    "nn": "Kom i gang",
    "en": "Get started"
  },
  "infopage.customer_header": {
    "nb": "Med Digipost Bedrift kan du:",
    "nn": "Med Digipost Bedrift kan du:",
    "en": "With Digipost Bedrift you can:"
  },
  "infopage.usp_1": {
    "nb": "Kommunisere sikkert med brukere og bedrifter",
    "nn": "Kommunisera sikkert med brukarar og bedrifter",
    "en": "Communicate securely with users and businesses"
  },
  "infopage.usp_2": {
    "nb": "Sende, motta og signere dokumenter",
    "nn": "Sende, motta og signere dokument",
    "en": "Send, receive and sign documents"
  },
  "infopage.usp_3": {
    "nb": "Dele og be om sensitive dokumenter, også rekommandert post",
    "nn": "Dele og be om sensitive dokument, også rekommandert post",
    "en": "Share and request sensitive documents, including registered mail"
  },
  "infopage.button": {
    "nb": "Start registrering",
    "nn": "Start registrering",
    "en": "Start registration"
  },
  "error.integration_partner_redirect_uri_validation": {
    "nb": "Parameteret redirect-url er ugyldig for denne partneren",
    "nn": "Teknisk feil: Parameteren redirect-url er ugyldig for denne partnaren",
    "en": "Technical error: The parameter redirect-url is invalid for this partner"
  },
  "error.integration_partner_id": {
    "nb": "Partneren du søker finnes ikke.",
    "nn": "Partnaren du søkjer, finst ikkje.",
    "en": "The partner you are searching for does not exist."
  }
}
